import { variantArmLabel } from "@hightouch/lib/cep/ab-test/message-variant-content";

/** Also the placeholder for a name input, so an empty name previews as what it resolves to. */
export function defaultVariantLabel(variantKey: string): string {
  return `Variant ${variantKey.toUpperCase()}`;
}

/**
 * True when a name is still the auto-filled default for `variantKey` (or was
 * never set) — i.e. the marketer hasn't customized it, so a re-key may rewrite
 * it to the new key's default.
 */
export function isDefaultVariantName(
  name: string,
  variantKey: string,
): boolean {
  return name.trim() === "" || name === defaultVariantLabel(variantKey);
}

/**
 * Takes the variant rather than name + key so every shape in this directory
 * (`MessageAbTestArm`, `VariantDraft`, `VariantSelectOption`) satisfies it
 * structurally.
 */
export function variantLabel(variant: {
  name?: string | null;
  variantKey: string;
}): string {
  return variantArmLabel({
    name: variant.name ?? null,
    variantKey: variant.variantKey,
  });
}
